export { default } from "./ContentContainer.styled";
